import * as API from './apiBase';

let baseList = {
    GetAuthCompanyList: 'api/InvoiceNew/GetAuthCompanyList',
    SetCompanyAuth: 'api/InvoiceNew/SetCompanyAuth',
}

/*获取公司列表 */
export const GetAuthCompanyList = (Auth, language) => {
    return API.POST(baseList.GetAuthCompanyList, {
        Auth,
        language
    })
};

/*公司授权 */
export const SetCompanyAuth = (CompanySAPCode, Auth, language) => {
    return API.POST(baseList.SetCompanyAuth, {
        CompanySAPCode,
        Auth,
        language
    })
};
